module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAAXNSR0IArs4c6QAAALlJREFUOE9jNE5L4xIQFVnGwMjozcDAwMJAPvjD8P//1g+v30QxOlVXZzAyMHg9Z2EJudbY+Mu5pvr/3pZWRlLN1qqvZ5P882fNfwaGbYxONVX1IAP2tbQ1gmhyDQXphZk1aij+MAWFMb5IQ47U0TAFJ0+CSWo0TIkuBkaTFHFJiugARSn6qqszGBgYvF5QoZCW+Pt7NcN/xu2Mxg0NXPx/fi1nZGD0orQ6+c/wf9tHFrZIkqsNYoIDANIe1QxGpmJ8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/Reading.png
// module id = R3l9
// module chunks = 96